var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_251_3160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00024 6.38038C9.74757 6.38038 11.1641 4.95208 11.1641 3.19019C11.1641 1.4283 9.74757 0 8.00024 0C6.25292 0 4.83643 1.4283 4.83643 3.19019C4.83643 4.95208 6.25292 6.38038 8.00024 6.38038Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.39897 7.93236H6.60119C4.74963 7.93236 3.24829 9.44583 3.24829 11.3135V16H12.7519V11.3135C12.7519 9.44583 11.2505 7.93236 9.39897 7.93236Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_251_3160"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.483ea74affa906bf5007c4f443ee7b85.svg";
export { ForwardRef as ReactComponent };